import React, { Fragment, Suspense, lazy } from 'react';
import styled from 'styled-components';

import GlobalStyle from '../styles/global';
import Spinner from './Spinner';

const Footer = lazy(() => import('./Footer'));
const WidgetWrapper = lazy(() => import('./WidgetWrapper'));

const AppStyle = styled.div`
  width: 100%;
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const AppPlaceholder = styled.div`
  position: fixed;
  display: flex;
  background: black;
  justify-content: center;
  opacity: 0.85;
  width: 100%;
  height: 100%;
`;

const MainContent = styled.div`
  flex: 1;
  position: relative;
`;
const renderLoader = () => (
  <AppPlaceholder>
    <Spinner />
  </AppPlaceholder>
);

const App = () => {
  return (
    <Fragment>
      <GlobalStyle />
      <AppStyle>
        <Suspense fallback={renderLoader()}>
          <MainContent>
            <WidgetWrapper />
          </MainContent>
          <Footer />
        </Suspense>
      </AppStyle>
    </Fragment>
  );
};

export default App;
